import { Store } from "@ngxs/store";
import { IDraftEmailManagerItem, IDraftEmailManagerFactory, EncounterDraftEmail, ReferralDraftEmail } from "@harlowe/core";
import { Encounters } from "../../../state/encounters/encounter-actions";
import { inject } from "@angular/core";
import { EncounterEmailHandler } from "../../encounter/encounter-editor/encounter-email-handler";


export class EncounterDraftEmailManagerItem implements IDraftEmailManagerItem
{

    private _handler?: EncounterEmailHandler

    constructor
    (
        private _draftEmail: EncounterDraftEmail | ReferralDraftEmail,
        private _store: Store
    )
    {

    }

    setEmailHandler(handler: EncounterEmailHandler)
    {
        this._handler = handler;
    }

    getHandler(): EncounterEmailHandler | undefined
    {
        return this._handler;
    }

    getDraftEmail(): EncounterDraftEmail| ReferralDraftEmail 
    {
        return this._draftEmail; 
    }

    goToRelatedItem(): void 
    {
        this._store.dispatch(new Encounters.EncounterOpenedFromEmailSidebar({encounterId:this._handler?.getRelatedObject().id as number}));
    }

}

export class EncounterDraftEmailManagerItemFactory implements IDraftEmailManagerFactory
{
    private _store: Store = inject(Store)

    constructor
    (
    )
    { 
    }

    createDraftEmailManagerItems(draftEmails: EncounterDraftEmail[] | ReferralDraftEmail[]): EncounterDraftEmailManagerItem[]
    {
        var ids : number[] = draftEmails.filter(draftEmail => draftEmail != undefined).map(draftEmail => draftEmail.draftEmailRelatedToId as number);
        if(ids && ids.length > 0)
        {
            return draftEmails.map
            (
                draftEmail => 
                    {
                        return new EncounterDraftEmailManagerItem(draftEmail, this._store);
                    }
            );

        }
        else
        {
            return [];
        }
    }

    createDraftEmailManagerItem(draftEmail: EncounterDraftEmail | ReferralDraftEmail): EncounterDraftEmailManagerItem
    {
        if (draftEmail instanceof EncounterDraftEmail)
            return this.createDraftEmailManagerItems([draftEmail] as EncounterDraftEmail[])[0];
        // ReferralDraftEmail
        return this.createDraftEmailManagerItems([draftEmail] as ReferralDraftEmail[])[0];
    }

    // TODO: Figure out how to update draftEmail items list after email is saved, deleted and sent

}

